import { Button, type ButtonProps } from '@mantine/core'
import React, { useCallback, useContext } from 'react'

import { useTranslation } from '@flecto/translations'

import { ModalsContext } from './ModalsProvider'
import classes from './styles.module.css'

type SubmitProps = ButtonProps & {
  label?: string
  form?: string
  preventClose?: boolean
  type?: 'submit'
  onClick?: () => void | Promise<void>
}

export function Submit({
  children,
  onClick,
  preventClose = false,
  ...props
}: SubmitProps) {
  const { t } = useTranslation('shared', { keyPrefix: 'actions' })
  const { closeModal } = useContext(ModalsContext)

  const handleSubmit = useCallback(async () => {
    await onClick?.()

    if (!preventClose) {
      closeModal()
    }
  }, [onClick])

  return (
    <Button
      variant='filled'
      className={classes.submit}
      onClick={handleSubmit}
      {...props}
    >
      {children || t('confirm')}
    </Button>
  )
}

Submit.displayName = 'ModalSubmit'
